export const benefitsPopupId = 'crmis-signup-benefitsPopup';
